export interface IChatHistory {
  items: IChatMessage[];
}

export interface IChatMessage {
  id: number;
  message_json: any;
  created_at: Date;
  is_read: boolean;
}

export interface IRequestFile {
  id: number;
  file_encode_base64: string;
  type: string;
  size: number;
  name: string;
}

export interface IResponseFile {
  id: number;
  file_display: string;
  type: string;
  size: number;
  name: string;
  uploading: boolean;
}

export class Message {
  id?: number;
  type: MessageType;
  content?: any;
  createdAt: number;
  isRead: boolean;

  constructor(
    id: number,
    type: MessageType,
    content: any,
    createdAt: number,
    isRead: boolean = false,
  ) {
    this.id = id;
    this.type = type;
    this.content = content;
    this.createdAt = createdAt;
    this.isRead = isRead;
  }
}

export enum MessageType {
  Bot = 'bot',
  User = 'user',
  Loading = 'loading',
}
